export enum DevicesFilters {
    All = 'All types',
    Pager = 'pager',
    Camera = 'camera',
    Intercom = 'intercom',
    Others = 'noType'
}

export enum StatusFilters {
    All = 'All',
    Offline = 'Offline',
    Online = 'Online'
}

export enum LocationsFilters {
    All = 'All locations',
    Others = 'Other locations'
}

